import React, { Component } from "react";
import uuid from "react-uuid";
import { toast } from "react-toastify";
import Loading from "../../../common/components/loading/loading";
import DualListBox from "../../../common/components/form/dualListBox";
import { withTranslation } from "react-i18next";
import { getUserAccounts } from "../../../common/services/auth/userAccountService";
import {
  getUserAccountsByOrganization,
  assignOrganization,
  revokeOrganization,
} from "../../../common/services/auth/userAccountOrganizationService";

class OrganizationUserAssignments extends Component {
  state = {
    options: [],
    selected: [],
    isLoading: true,
  };

  async componentDidMount() {
    const { organizationId } = this.props;

    try {
      const allUsers = await getUserAccounts();
      const usersInOrg = await getUserAccountsByOrganization(organizationId);

      this.setState({
        options: this.mapToOptionsViewModel(allUsers),
        selected: this.mapToSelectedViewModel(usersInOrg),
        isLoading: false,
      });
    } catch (error) {
      console.error(error);
      toast.error(this.props.t("LoadFailed"));
      this.setState({ isLoading: false });
    }
  }

  mapToOptionsViewModel(users) {
    return users.map((user) => {
      const fullName =
        user.firstName || user.lastName
          ? `${user.firstName || ""} ${user.lastName || ""}`.trim()
          : "";

      return {
        value: user.userAccountId,
        label: fullName ? `${user.login} (${fullName})` : user.login,
      };
    });
  }

  mapToSelectedViewModel(users) {
    return users.map((user) => user.userAccountId);
  }

  async handleChange(selected, selection, controlKey) {
    const { organizationId } = this.props;
    const eventId = uuid();

    if (controlKey !== "available" && controlKey !== "selected") {
      toast.warning(this.props.t("UnexpectedError"));
      return null;
    }

    this.setState({ selected });

    for (const userAccountId of selection) {
      if (controlKey === "available") {
        try {
          await assignOrganization(userAccountId, {
            organizationId,
            eventId,
          });
          toast.success(this.props.t("UserAdded"));
        } catch (ex) {
          console.log(ex);
          const index = selected.indexOf(userAccountId);
          if (index > -1) selected.splice(index, 1);
          toast.warning(this.props.t("UserAdditionFailed"));
        }
      } else if (controlKey === "selected") {
        try {
          await revokeOrganization(userAccountId, {
            organizationId,
            eventId,
          });
          toast.success(this.props.t("UserRemoved"));
        } catch (ex) {
          console.log(ex);
          selected.push(userAccountId);
          toast.warning(this.props.t("UserRemovalFailed"));
        }
      }
    }

    this.setState({ selected });
  }

  render() {
    const { options, selected, isLoading } = this.state;
    const { allowEdit } = this.props;

    if (isLoading) return <Loading />;

    return (
      <div>
        <DualListBox
          canFilter
          className="rdl-hide-move-all"
          disabled={!allowEdit}
          options={options}
          selected={selected}
          onChange={(selected, selection, controlKey) =>
            this.handleChange(selected, selection, controlKey)
          }
        />
      </div>
    );
  }
}

export default withTranslation(["auth"])(OrganizationUserAssignments);
